import { Constants } from "../shared/constants"

export const bookedeventData = [
    {
        img: Constants.customImages.EventAvatar,
        name: "Dance challenge",
    },
    {
        img: Constants.customImages.PencilBookedEve,
        name: "Designing competition",
    },
    // {
    //     img: Constants.customImages.DrawingBookedEve,
    //     name: "Drawing",
    // },
    // {
    //     img: Constants.customImages.PencilBookedEve,
    //     name: "Water colouring",
    // },
    // {
    //     img: Constants.customImages.EventAvatar,
    //     name: "Drawing & Painting",
    // },
]